import { ExpressPaymentMethods, PlaceOrderAndTosVariant } from './types';

const TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER =
    'checkout_ticket_selection_page_experiments';
const ORDER_FORM_PAGE_EXPERIMENTS_LAYER = 'checkout_checkout_page_experiments';

export const URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT = {
    defaultValue: false,
    layer: TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER,
    param: 'urgency_signals_visible',
};

export const SCROLLABLE_CTA_ON_TICKET_SELECTION_PAGE_EXPERIMENT = {
    defaultValue: false,
    layer: TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER,
    param: 'scrollable_cta',
};

export const GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT = {
    defaultValue: ExpressPaymentMethods.paypal,
    layer: TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER,
    param: 'enable_express_google_pay',
};

export const SCROLLABLE_PLACE_ORDER_AND_TOS = {
    defaultValue: PlaceOrderAndTosVariant.ctaOnStickyFooter,
    layer: ORDER_FORM_PAGE_EXPERIMENTS_LAYER,
    param: 'scrollable_place_order',
};
